// 9fbef606107a605d69c0edbcd8029e5d
import deleteAddress from '@tcp/core/src/queries/deleteCustomerAddress.query.graphql';
import { executeStatefulGraphQLQuery } from '../../handler';

const errorHandler = (err) => {
  if (err.response && err.response.body && err.response.body.errors) {
    throw new Error(err.response.body.errors[0].errorMessage);
  }
  throw new Error('Your action could not be completed due to system error!!!!');
};

const deleteAddressApi = (payload) => {
  return executeStatefulGraphQLQuery({
    query: deleteAddress,
    variables: {
      deleteCustomerAddressAddressId: payload.addressId,
    },
    type: 'mutation',
  })
    .then((res) => {
      return res;
    })
    .catch(errorHandler);
};

export default deleteAddressApi;
